import {
  validatePhone,
  validateEmailAddress,
  validate,
} from '@bingads-webui-campaign-react/smart-component-util';
import {
  validateLocation,
  validateGeoLocation,
  validateHours,
} from './components/validations';
import { dataProperties } from './data-config';

export function getErrors({
  showPhone,
  phoneNumber,
  showEmail,
  email,
  showLocation,
  locationInfo,
  showMap,
  geoLocationInfo,
  showHours,
  businessHours,
  i18n,
}) {
  const errors = validate([{
    name: dataProperties.phoneNumber,
    value: phoneNumber,
    validators: [{
      validateWhenTrue: showPhone,
      validator: validatePhone,
      errorMessage: i18n ? i18n.getString(_TL_('Invalid phone number.')) : null,
    }],
  }, {
    name: dataProperties.emails,
    value: email,
    validators: [{
      validateWhenTrue: showEmail,
      validator: validateEmailAddress,
      errorMessage: i18n ? i18n.getString(_TL_('Invalid email address.')) : null,
    }],
  }, {
    name: dataProperties.locationInfo,
    value: locationInfo,
    validators: [{
      validateWhenTrue: showLocation,
      validator: validateLocation,
      errorMessage: i18n ? i18n.getString(_TL_('Invalid address.')) : null,
    }],
  }, {
    name: dataProperties.businessHours,
    value: businessHours,
    validators: [{
      validateWhenTrue: showHours,
      validator: validateHours,
      errorMessage: i18n ? i18n.getString(_TL_('Invalid hours.')) : null,
    }],
  }]);

  const warnings = validate([
    {
      name: dataProperties.locationInfo,
      value: geoLocationInfo,
      validators: [{
        validateWhenTrue: showMap,
        validator: validateGeoLocation,
        errorMessage: i18n ? i18n.getString(_TL_('We can\'t find your business address on Bing Maps.')) : null,
      }],
    },
  ]);

  return { errors, warnings };
}
